import { render, staticRenderFns } from "./head.vue?vue&type=template&id=22cc94bf&scoped=true&"
import script from "./head.vue?vue&type=script&lang=js&"
export * from "./head.vue?vue&type=script&lang=js&"
import style0 from "./head.vue?vue&type=style&index=0&lang=css&"
import style1 from "./head.vue?vue&type=style&index=1&id=22cc94bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc94bf",
  null
  
)

export default component.exports